export default __webpack_public_path__ + "static/media/gp.d1864308.svg";